<template>
    <div class="catalog-button" :class="{active}" @mouseenter="preloadMenu" @click="activate(0)">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" fill="none" viewBox="0 0 15 13"><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="M.6.6h13.333M.6 6.433h13.333M.6 12.266h13.333"/></svg>
        Каталог
    </div>
    <teleport to="#main-menu-target">
        <LazyIdleHeaderTopMenuContent hydrate-on-idle v-model="active" :current></LazyIdleHeaderTopMenuContent>
    </teleport>
    
</template>


<script setup lang="ts">
import { useDialogStore } from '~/store/dialogStore';
import { useMenuStore } from '~/store/menuState';


const current = ref(0);
const prev = ref(0);
const active = ref(false);

function activate(type: number) {
    if (active.value && type === current.value) {
        active.value = false;
        return;
    }

    active.value = true;
    prev.value = current.value;
    current.value = type;
}

const menuStore = useMenuStore();

function preloadMenu() {
    menuStore.tryInit();
}


const dialogStore = useDialogStore();
watch(active, () => dialogStore.set('main-menu', active.value));

const router = useRouter();
router.afterEach(() => {
    active.value = false;
});

</script>

<style lang="scss" scoped>

.catalog-button {
    position: relative;
    display: flex;
    background-color: var(--pink);
    font-weight: 450;
    border-radius: 17px;
    color: white;
    gap: 7px;

    padding: 7px 17px;
    height: 38px;
    // outline: 1px solid red;
    border-radius: 19px;
    user-select: none;
    cursor: pointer;
    z-index: 1;
    display: inline-flex;
    align-items: center;
}


</style>